import {UUID} from 'yougile-util'
import {BoardFilters} from '../../extensions/sticker/board-filters'
import {ComponentUpdater} from './index'

export const BoardFilterUpdater: () => ComponentUpdater<UUID> = () => {
  return {
    displayName: `BoardFilter`,
    onMount(update: () => void): UUID {
      return BoardFilters.addListener(update)
    },
    onUnmount(id: UUID): void {
      BoardFilters.removeListener(id)
    }
  }
}
